import clsx from 'clsx';
export const cn = (...inputs) => clsx(inputs);
